export default "__VITE_ASSET__hEAY6FOv__"